<template>
  <div class="body">
    <div class="aboutsection wf-section">
      <p class="paragraph-5">Support dublab</p>
    </div>
    <div class="section-2 wf-section">
      <div class="container-4 w-container" id="major-donors">
        <h1 id="core-values" class="values">Become a Major Donor</h1>
        <p class="majordonor">
          Friends who are able to donate $5,000 or more, provide dublab with the
          dollar resources that help keep the station they love available to
          everyone while also enjoying a deeper level of connection for
          themselves.<br />‍<br />Major Donor benefits are unique because
          they’re also some of the ways that allow dublab to invest back into
          our community.<br />‍<br />Development of new culturally enriching
          radio shows, internships for youth, and skill-building programs for
          artists are a few of the projects that Major Donors support.<br />Major
          Donors receive special recognition and connection to dublab – our
          favorite way of showing our appreciation for helping keep the future
          of dublab alive.<br />‍<br />Email
          <a href="mailto:donate@dublab.com">donate@dublab.com</a> for more
          information on how you can become a dublab Major Donor and enjoy these
          super benefits.
        </p>
        <runtime-content :content="mainContent"></runtime-content>
        <div v-if="page.tabs">
          <form class="tabs">
            <div class="radio-group">
              <div v-for="(tab, key) in getTabs" class="radio-pill" :key="key">
                <input
                  type="radio"
                  :id="'tab-' + key"
                  :value="key"
                  name="tabs"
                  v-model="active"
                />
                <label :for="'tab-' + key">{{ tab.title }}</label>
              </div>
            </div>
            <select class="pill" v-model="active">
              <option v-for="(tab, key) in getTabs" :value="key" :key="key">
                {{ tab.title }}
              </option>
            </select>
          </form>
          <div v-if="getTabItems" :class="['tab-items', getTabItemsTemplate]">
            <AboutThumb
              v-for="item in getTabItems"
              :item="item"
              :template="getTabItemsTemplate"
              :key="item.title"
            ></AboutThumb>
          </div>
          <div v-if="getActive" class="tab-totals pill-hover">
            <div>Total: {{ getActive.title }}</div>
            <a v-if="getActive.link" :href="getActive.link" class="pill">{{
              getActive.link_text
            }}</a>
          </div>
        </div>
      </div>
      <div class="container mission w-container">
        <div class="keep-us-on-air">
          <p class="lilp">
            Our listeners and supporters help us stay on air. Keep dublab going
            strong!
          </p>
        </div>
      </div>
      <div class="container-5 history w-container">
        <div class="div-block-19"></div>
        <div class="div-block-20">
          <img
            src="../assets/images/Jeremiah-Chiu---Zoom-Room-1.jpg"
            loading="lazy"
            sizes="(max-width: 991px) 80vw, 940px"
            srcset="
              ../assets/images/Jeremiah-Chiu---Zoom-Room-1-p-500.jpg   500w,
              ../assets/images/Jeremiah-Chiu---Zoom-Room-1-p-800.jpg   800w,
              ../assets/images/Jeremiah-Chiu---Zoom-Room-1-p-1080.jpg 1080w,
              ../assets/images/Jeremiah-Chiu---Zoom-Room-1-p-1600.jpg 1600w,
              ../assets/images/Jeremiah-Chiu---Zoom-Room-1.jpg        1920w
            "
            alt=""
            class="image-18"
          />
        </div>
        <h1 id="supporter-circle" class="values">Join Our Supporter Circle</h1>
        <p class="paragraph-10">
          dublab’s Supporter Circle is a great way to make a meaningful impact
          in the organization’s programming and operational activities. Your
          annual gift will go towards the financial stability of the
          organization, ensuring that the station’s radio broadcasts and its
          educational and community-enriching initiatives continue to expand and
          reflect the world around us.<br /><br />Join the Supporter Circle
          today at $1,500, $2,500, or $3,500 and enjoy these benefits for one
          year:<br />
        </p>
        <ul role="list" class="list-2 gifst" id="benefits">
          <li class="fact">
            Annual Supporter Circle dinner with dublab staff, DJs, and Board Members
          </li>
          <li class="fact">
            Acknowledgement of your support on dublab’s website
          </li>
          <li class="fact">
            Free tickets to exclusive concerts and live events throughout the year
          </li>
          <li class="fact">
            Tickets to dublab's Creative Cultivation Salon and Anniversary Party
          </li>
          <li class="fact">
            Quarterly newsletter for Supporter Circle members
          </li>
          <li class="fact">
            Your donation is tax deductible
          </li>
        </ul>
        <div class="button-holder">
          <a href="https://buy.stripe.com/7sI8xQ2epdDfgdG000" rel="blank">
            <button class="button pill hover">$1,500 a year</button>
          </a>
          <a href="https://buy.stripe.com/9AQ29s4mx9mZ8Le9AC" rel="blank">
            <button class="button pill hover">$2,500 a year</button>
          </a>
          <a href="https://buy.stripe.com/aEUg0if1b42F8Le5kl" rel="blank">
            <button class="button pill hover">$3,500 a year</button>
          </a>
        </div>
      </div>
      <div class="container-5 dei w-container">
        <div class="div-block-19">
          <div class="div-block-20">
            <img
              src="../assets/images/studio_transparency.png"
              loading="lazy"
              sizes="(max-width: 991px) 80vw, 940px"
              srcset="
                ../assets/images/studio_transparency.png  500w,
                ../assets/images/studio_transparency.png  800w,
                ../assets/images/studio_transparency.png 1080w,
                ../assets/images/studio_transparency.png 1600w,
                ../assets/images/studio_transparency.png 2000w
              "
              alt=""
              class="image-18"
            />
          </div>
        </div>
        <h1 id="sponsor" class="values core-values">
          Become a Year-Round Supporter/Sponsor
        </h1>
        <p class="paragraph-10">
          Underwrite dublab’s radio programming, connect with our audience and
          be part of our ever-expanding universe. Your company will receive
          public acknowledgement through on-air mentions, website announcements
          and social media posts. <br /><br />For rates and customized plans
          please contact us at <a
          class="dublab-email-links"
          href="mailto:donate@dublab.com?subject=dublab Donation"
          >donate@dublab.com</a>
        </p>
      </div>
      <div class="container-5 history w-container other-support">
        <div class="div-block-19"></div>
        <h1 id="other" class="values">Other Ways to Support</h1>
        <ul role="list" class="list-2" id="dubfacts">
          <li class="fact">
            We greatly welcome in-kind (non-monetary) donations! If you have
            office supplies, audio equipment, computers, or other items you
            think could be useful to dublab, please contact us at
            <a href="mailto:donate@dublab.com">donate@dublab.com</a>.
          </li>
          <li class="fact">
            Shopping through affiliate programs like
            <a href="http://www.benevity.com/">Benevity</a> will contribute a
            percentage of your purchases to benefit dublab at no extra charge to
            you!
          </li>
          <li class="fact">
            Support from foundations allows dublab to grow and further our
            mission. If you are a foundation interested in helping dublab
            provide a space for LA’s creative community, please email us at
            <a href="mailto:donate@dublab.com">donate@dublab.com</a>.
          </li>
          <li class="fact">
            Create a Legacy: You can make a long-lasting impact on the future of dublab by indicating a gift to the organization in your will or trust. For suggested bequest language or to learn more, please contact us at <a href="mailto:donate@dublab.com">donate@dublab.com</a>
          </li>
          <li class="fact">
            Gift of Stock: You can transfer stock to dublab. Donate appreciated stock and you may avoid paying capital gains tax. For more details, please contact us at <a href="mailto:donate@dublab.com">donate@dublab.com</a>
          </li>
          <li class="fact">
            Beneficiary Designations: Do you have a life insurance policy or retirement account? Consider making dublab a full or partial beneficiary. Please discuss this with the advisor who handles your life insurance policy or retirement account.
          </li>
          <li class="fact">
            IRA Distributions: Are you required to take a minimum distribution from your IRA but don't need it or want it to affect your income? You can donate the distribution directly to dublab, and you may save money on your taxes. Talk to your financial advisor on how to make this happen.
          </li>
          <li class="fact">
            A great way to clear some space from your garage and support your
            favorite radio station. Call (866) 398-4483 or visit our vehicle
            donation page with
            <a href="https://www.careasy.org/nonprofit/future-roots">CARS</a
            >. It only takes a few minutes to complete the initial donation
            forms, and they’ll walk you through the rest of the process step by
            step.
          </li>
          <li class="fact">
            We are always looking for volunteers! We need support in the
            following fields: Programming, grants, administrative services,
            events, and content production/creation. If you’re interested in
            volunteering with us, please email
            <a href="mailto:info@dublab.com">info@dublab.com</a>.
          </li>
        </ul>
        <div class="text-block-8">
          dublab is a program of Future Roots Inc., a non-profit organization
          licensed under section 501(c)(3) of the U.S. Internal Revenue code.
          Any contribution made to dublab is tax deductible.
        </div>
      </div>
      <div class="container-7 w-container">
        <div class="div-block-4">
          <div class="text-block-5">Contact us</div>
          <div class="div-block-5">
            <div class="div-block-6">
              <p class="paragraph-4">
                dublab<br />1035 West 24th Street<br />Los Angeles, CA 90007
              </p>
            </div>
            <div class="div-block-6">
              <p class="paragraph-4">
                General inquiries and promotional materials:<br />‍<a
                  class="dublab-email-links"
                  href="mailto:info@dublab.com?subject=dublab Support Inquiry"
                  >info@dublab.com</a
                >
              </p>
            </div>
            <div class="div-block-6">
              <p class="paragraph-4">
                Donations:<br /><a
                  class="dublab-email-links"
                  href="mailto:donate@dublab.com?subject=dublab Donation"
                  >donate@dublab.com</a
                ><br />‍<br />Technical Assistance:<br /><a
                  class="dublab-email-links"
                  href="mailto:webops@dublab.com?subject=Tech Assistance"
                  >webops@dublab.com</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import delve from "dlv";
import { mixin } from "@/lib/content-state";

import AboutThumb from "@/components/AboutThumb";
import RuntimeContent from "@/components/RuntimeContent";

export default {
  name: "SupportPage",
  components: { AboutThumb, RuntimeContent },
  mixins: [mixin],
  data() {
    return {
      navigation: {
        active: this.$route.path,
      },
      active: null,
    };
  },
  watch: {
    "$route.path": function (value) {
      if (this.navigation.active !== value) {
        this.navigation.active = value;
      }
    },
    "navigation.active": function (value) {
      if (value.substring(0, 4) === "http") window.location = value;
      else this.$router.push(value);
    },
  },
  mounted() {
    // active

    // link jumping
    if (this.$route.hash) {
      const el = document.querySelector(this.$route.hash);
      if (el) {
        const { top } = el.getBoundingClientRect();
        window.scrollTo(0, top - 80);
      }
    }
  },
  computed: {
    isSupport() {
      return this.$route.name === "supporters";
    },
    getTabs() {
      return delve(this.page, "tabs.options");
    },
    getTabItems() {
      if (delve(this.page, "tabs.entries")) {
        return this.page.tabs.entries.filter((item) => {
          return item.level.indexOf(this.active) >= 0;
        });
      } else return null;
    },
    getActive() {
      if (delve(this.page, "tabs.options")) {
        // reset active to first tab if necessary
        const keys = Object.keys(this.page.tabs.options);
        if (keys.indexOf(this.active) < 0) this.resetActive(keys);

        // return active tab
        return this.page.tabs.options[this.active];
      } else return null;
    },
    getTabItemsTemplate() {
      return this.$route.params.section === "donations" ? "block" : "row";
    },
    sidebarContent() {
      return `<div class="copy pill-hover">${this.page.subcontent}</div>`;
    },
    mainContent() {
      return `<div class="copy">${this.page.content}</div>`;
    },
  },
  methods: {
    resetActive(keys) {
      this.active = keys[0];
    },
  },
};
</script>
<style scoped>
.section {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 60vh;
  max-height: 800px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("../assets/images/dublab_front_with_logo.jpg");
  background-position: 50% 75%;
  background-size: cover;
}

.container {
  max-width: 66%;
}

.w-container {
  margin: 0 auto;
  margin-top: 80px;
  width: 66%;
  max-width: 1000px;
}

.container.mission {
  margin-top: 0px;
}

.button-holder {
  display: flex;
  justify-content: space-around;
}

.other-support a {
  text-decoration: underline;
}

.paragraph {
  width: 70%;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
  font-family: Suisseneue, sans-serif;
  font-size: 18px;
  line-height: 25px;
}

.mission-statement {
  display: block;
  height: 340px;
  margin-top: 60px;
  margin-bottom: 40px;
  border: 1px solid #000;
  border-radius: 40px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.text-block {
  font-family: Suisseintlmono, sans-serif;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  text-transform: uppercase;
}

.text-block-2 {
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 14px;
}

.paragraph-2 {
  max-width: 65%;
}

.paragraph-3 {
  width: 75%;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 40px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  font-size: 22px;
  line-height: 38px;
}

.directory-row {
  margin-bottom: 60px;
  border-top: 1px solid #000;
  font-size: 13px;
}

.text-block-3 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: Suisseintlmono, sans-serif;
  text-transform: uppercase;
}

.img-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0px;
  padding-top: 0px;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.img-holder {
  position: relative;
  height: 180px;
  margin-right: 2%;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  -ms-grid-row-align: auto;
  align-self: auto;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  border-style: none;
  border-width: 1px;
  border-color: transparent;
  border-radius: 12px;
  text-align: left;
}

.div-block-2 {
  position: relative;
  width: 32%;
  height: 180px;
  -o-object-fit: none;
  object-fit: none;
}

.image {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-2 {
  display: inline-block;
  max-height: 100%;
  min-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.image-3 {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.text-block-4 {
  position: absolute;
  left: 0%;
  top: 0%;
  right: auto;
  bottom: auto;
  display: inline-block;
  margin-top: 10px;
  margin-left: 15px;
  float: none;
  clear: left;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
}

.mission-statement-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 340px;
  margin-top: 60px;
  margin-bottom: 40px;
  padding: 30px;
  border: 1px dashed #000;
  border-radius: 30px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.div-block-3 {
  width: 33%;
}

.image-4 {
  height: auto;
  max-height: 100%;
  min-height: 100%;
  min-width: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.link-block {
  color: #000;
  text-decoration: none;
}

.div-block-4 {
  height: 180px;
  border-top: 1px solid #000;
  border-radius: 1px;
}

.section-2 {
  border: 1px none #000;
}

.text-block-5 {
  margin-top: 10px;
  margin-bottom: 10px;
  font: var(--small_mono);
  text-transform: uppercase;
  text-align: left;
}

.div-block-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  grid-column-gap: 5%;
  grid-row-gap: 5%;
  margin-top: 30px;
}

.paragraph-4 {
  -webkit-box-ordinal-group: 0;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.div-block-6 {
  width: 30%;
  font-family: Adieu, sans-serif;
  font-size: 20px;
  line-height: 24px;
  font-weight: 300;
  -webkit-text-align: left;
  text-align: left;
}

.image-5 {
  width: 100%;
  margin-top: 60px;
}

.paragraph-5 {
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 80px;
  line-height: 70px;
  text-transform: none;
  text-shadow: 0 0 6px #000;
}

.heading {
  margin-top: 0px;
  margin-bottom: 20px;
  margin-left: auto;
  font-family: Adieu, sans-serif;
  font-size: 32px;
  line-height: 40px;
  font-weight: 300;
}

.heading.yearly {
  font-weight: 400;
}

.body {
  margin-right: auto;
  text-align: center;
}

.div-block-7 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 20px;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  grid-column-gap: 2.5%;
  grid-row-gap: 2.5%;
}

.div-block-8 {
  display: block;
  width: 23%;
  height: 15%;
  max-height: 15%;
  max-width: none;
  min-height: 15%;
  min-width: 150px;
  margin-right: 0%;
  margin-bottom: 40px;
  -webkit-box-ordinal-group: 2;
  -webkit-order: 1;
  -ms-flex-order: 1;
  order: 1;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-9 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 120%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: baseline;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  -webkit-align-content: space-around;
  -ms-flex-line-pack: distribute;
  align-content: space-around;
}

.paragraph-6 {
  margin-top: 10px;
  font-family: Adieu, sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  text-align: left;
}

.div-block-10 {
  margin-bottom: 50px;
  border-top: 1px solid #000;
}

.paragraph-7 {
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 84px;
  line-height: 90px;
  font-weight: 300;
  text-align: center;
}

.aboutsection {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  margin-bottom: -70px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("../assets/images/Jeremiah-Chiu---Zoom-Room-2.jpg");
  background-position: 50% 50%;
  background-size: cover;
  background-clip: border-box;
  -webkit-text-fill-color: inherit;
}

.section-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("../assets/images/Dublab-4.jpg");
  background-position: 50% 70%;
  background-size: cover;
}

.section-copy-copy {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow: visible;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: transparent;
  background-image: url("../assets/images/dublab_blues.png");
  background-position: 50% 50%;
  background-repeat: repeat;
  background-attachment: scroll;
  -o-object-fit: fill;
  object-fit: fill;
}

.paragraph-8 {
  margin-top: -50px;
  padding-top: 0px;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 80px;
  line-height: 90px;
}

.image-6 {
  background-color: transparent;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.image-7 {
  position: absolute;
  left: auto;
  top: auto;
  right: 0%;
  bottom: 0%;
}

.image-8 {
  overflow: auto;
  -o-object-fit: cover;
  object-fit: cover;
}

.flexycontainer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 60px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-align-content: space-between;
  -ms-flex-line-pack: justify;
  align-content: space-between;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 30px;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
}

.flexycontainer.rogueflex {
  width: 725.3359375px;
  margin-right: auto;
  margin-bottom: 80px;
  margin-left: auto;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.flexycontainer.mids {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.image-9 {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100%;
  margin-bottom: 20px;
  padding-bottom: 0px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-10 {
  background-color: transparent;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.image-11 {
  max-height: 80%;
  margin-top: 0px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 0px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.text-block-6 {
  font-family: Suisseneue, sans-serif;
  font-size: 24px;
  line-height: 40px;
  font-weight: 300;
}

.text-block-7 {
  font-family: Suisseneue, sans-serif;
  font-size: 24px;
  line-height: 40px;
  font-weight: 300;
}

.div-block-11 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-weight: 400;
}

.div-block-12 {
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  -ms-grid-row-align: auto;
  align-self: auto;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.div-block-13 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.div-block-14 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.grid {
  display: -ms-grid;
  display: grid;
  min-width: 100%;
  grid-auto-flow: row;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-areas: "Area";
  -ms-grid-columns: 1fr 16px 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto 16px auto;
  grid-template-rows: auto auto;
}

.div-block-15 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 47%;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-15.mids {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-16 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 46%;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
}

.div-block-17 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 46%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.heading-2 {
  margin-top: 0px;
  font-family: Suisseintlmono, sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.paragraph-9 {
  font-family: Suisseneue, sans-serif;
  font-weight: 400;
  text-align: left;
}

.div-block-18 {
  width: 4%;
}

.container-2 {
  max-width: 66%;
}

.container-3 {
  max-width: 78%;
}

.image-13 {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.heading-3 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #333;
  font-weight: 300;
}

.image-14 {
  min-height: 100%;
  min-width: 100%;
}

.link-block-2 {
  width: 32%;
}

.container-4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 66%;
  margin-top: 80px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.values {
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  font-family: Adieu, sans-serif;
  font-size: 34px;
  line-height: 50px;
  font-weight: 300;
}

.list-item {
  list-style-type: circle;
}

.list {
  display: block;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-family: Suisseintlmono, sans-serif;
  list-style-type: decimal;
}

.corevalue {
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 22px;
}

.container-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.container-5.dei {
  margin-bottom: 0px;
}

.paragraph-10 {
  font-family: Suisseneue, sans-serif;
  font-size: 20px;
  text-align: left;
  line-height: 28px;
  font-weight: 400;
}

.div-block-19 {
  width: 100%;
  border: 0px solid #000;
  border-radius: 0px;
}

.list-item-2 {
  margin-bottom: 20px;
}

.fact {
  list-style: disc;
  margin-bottom: 30px;
  font-family: Suisseintlmono, sans-serif;
  font-size: 16px;
  line-height: 22px;
}

#benefits .fact {
  margin-left: 80px;
}

.list-2 {
  padding-top: 24px;
  padding-bottom: 53px;
  font-family: Montserrat, sans-serif;
  text-align: left;
}

.image-16 {
  position: static;
  height: 100%;
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-17 {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.majordonor {
  font-family: Suisseneue, sans-serif;
  font-size: 20px;
  line-height: 28px;
  text-align: left;
}

.toggle {
  margin-top: 40px;
  padding: 40px 20px;
  border: 2px solid #000;
  border-radius: 12px;
  font-family: Adieu, sans-serif;
  font-size: 34px;
  line-height: 44px;
  text-transform: uppercase;
}

.lilp {
  width: 80%;
  margin-top: 60px;
  margin-right: auto;
  margin-left: auto;
  font-size: 32px;
}

.keep-us-on-air {
  display: block;
  height: 220px;
  margin-top: 60px;
  margin-bottom: 40px;
  border: 1px solid #000;
  border-radius: 40px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.div-block-20 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 45vh;
  max-width: 100%;
  min-height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.image-18 {
  height: 100%;
  max-height: 100%;
  min-width: auto;
  -o-object-fit: cover;
  object-fit: cover;
}

.text-block-4-copy {
  position: absolute;
  left: 0%;
  top: 0%;
  right: auto;
  bottom: auto;
  display: inline-block;
  margin-top: 10px;
  margin-left: 15px;
  float: none;
  clear: left;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
}

.aboutsection-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: rgba(41, 89, 151, 0.8);
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(41, 107, 194, 0.7)),
      to(rgba(41, 107, 194, 0.7))
    ),
    url("../assets/images/Dublab-3.jpg");
  background-image: linear-gradient(
      180deg,
      rgba(41, 107, 194, 0.7),
      rgba(41, 107, 194, 0.7)
    ),
    url("../assets/images/Dublab-3.jpg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, cover;
  background-clip: border-box;
  -webkit-text-fill-color: inherit;
}

.heading-3-copy {
  display: block;
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: gold;
  font-weight: 300;
  text-decoration: underline;
}

.heading-3-copy2 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #9b9b9b;
  font-weight: 300;
  text-decoration: underline;
}

.heading-3-copy5 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #b08d57;
  font-weight: 300;
  text-decoration: underline;
}

.text-block-8 {
  width: 80%;
  margin-bottom: 38px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  font-family: Adieu, sans-serif;
  font-weight: 300;
  text-align: center;
}

.img-row-copyer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: -46px;
  padding-top: 0px;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.goldimg {
  display: none;
  width: 30%;
  max-width: 30%;
  margin-bottom: 54px;
}

a.dublab-email-links {
  color: var(--accent);
}

@media screen and (max-width: 991px) {
  .paragraph {
    width: 100%;
  }

  .paragraph-3 {
    font-size: 20px;
    line-height: 33px;
  }

  .image-4 {
    min-height: 100%;
    -o-object-fit: scale-down;
    object-fit: scale-down;
  }

  .section-2 {
    line-height: 22px;
  }

  .paragraph-4 {
    font-size: 14px;
    line-height: 20px;
  }

  .flexycontainer.rogueflex {
    width: auto;
  }

  .div-block-15 {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
  }

  .div-block-15.mids {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .div-block-17 {
    display: none;
  }

  .image-15 {
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .container-5.dei {
    max-width: 80%;
  }

  .container-5.history {
    max-width: 80%;
  }

  .image-16 {
    height: auto;
  }

  .lilp {
    margin-top: 0px;
    font-size: 30px;
    line-height: 38px;
  }

  .keep-us-on-air {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
}

@media screen and (max-width: 767px) {
  .container {
    max-width: 80%;
  }

  .container.mission {
    max-width: 80%;
  }

  .mission-statement {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .text-block {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .paragraph-3 {
    padding-left: 0px;
    font-size: 17px;
    line-height: 25px;
  }

  .text-block-4 {
    font-size: 14px;
    line-height: 20px;
  }

  .div-block-4 {
    display: none;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .paragraph-4 {
    font-size: 12px;
    line-height: 16px;
  }

  .paragraph-5 {
    font-size: 60px;
  }

  .div-block-7 {
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
  }

  .div-block-8 {
    min-width: 180px;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .paragraph-6 {
    font-size: 16px;
    line-height: 20px;
  }

  .container-2 {
    max-width: 80%;
  }

  .container-4 {
    max-width: 80%;
  }

  .container-5.history {
    max-width: 80%;
  }

  .paragraph-10 {
    max-width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    font-size: 18px;
    line-height: 26px;
  }

  .div-block-19 {
    width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
  }

  .list-2 {
    max-width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
  }

  .majordonor {
    font-size: 18px;
    line-height: 26px;
  }

  .lilp {
    font-size: 26px;
    line-height: 34px;
  }

  .text-block-4-copy {
    font-size: 14px;
    line-height: 20px;
  }

  .heading-3-copy {
    display: block;
  }

  .goldimg {
    display: none;
  }

  .container-6 {
    max-width: 80%;
  }

  .container-7 {
    max-width: 80%;
  }
}

@media screen and (max-width: 479px) {
  .container {
    max-width: 85%;
  }

  .mission-statement {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .text-block {
    margin-top: 0px;
    margin-bottom: 20px;
  }

  .paragraph-3 {
    font-size: 16px;
    line-height: 19px;
  }

  .img-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-align-content: stretch;
    -ms-flex-line-pack: stretch;
    align-content: stretch;
  }

  .img-holder {
    height: auto;
  }

  .paragraph-5 {
    display: block;
    margin-right: auto;
    margin-left: auto;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
    font-size: 44px;
    line-height: 54px;
    text-align: center;
  }

  .heading {
    font-size: 28px;
  }

  .div-block-7 {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .div-block-8 {
    width: 70%;
  }

  .flexycontainer {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }


  .div-block-15 {
    width: 100%;
  }

  .values {
    font-size: 24px;
    line-height: 30px;
    text-align: center;
  }

  .container-5.dei {
    max-width: 80%;
  }

  .paragraph-10 {
    font-size: 18px;
    line-height: 24px;
  }

  .majordonor {
    font-size: 18px;
    line-height: 24px;
  }

  .lilp {
    font-size: 20px;
    line-height: 28px;
  }

  .text-block-4-copy {
    font-size: 12px;
    line-height: 16px;
  }

  .container-6 {
    display: none;
  }

  .container-7 {
    display: none;
    max-width: 95%;
  }
}

@font-face {
  font-family: "Adieu";
  src: url("../assets/fonts/Adieu-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Suisseintlmono";
  src: url("../assets/fonts/SuisseIntlMono-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "AdieuLight";
  src: url("../assets/fonts/Adieu-Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Suisseneue";
  src: url("../assets/fonts/SuisseNeue-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
</style>
